var map = {
	"./Checkmark.svg": 336,
	"./Hamburger-Menu.svg": 916,
	"./Page-Image.png": 425,
	"./Sign-Up-Image.png": 904,
	"./User-Avatar-2.svg": 974,
	"./User-Avatar-32.svg": 235,
	"./User-Avatar.svg": 4,
	"./allSizes.svg": 475,
	"./code.svg": 350,
	"./girl.jpg": 591,
	"./hero-Illustration.png": 598,
	"./hide password.svg": 323,
	"./star.svg": 111,
	"./time.svg": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;